import { FC, SVGProps } from 'react'

export const Ethereum: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.3501 2.48438V30.4844"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.3501 16.4844L16.3501 21.4844L5.3501 16.4844"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3501 2.48438L27.3501 16.4844L16.3501 30.4844L5.3501 16.4844L16.3501 2.48438Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
